export default {
    root: function (_a) {
        var _b, _c;
        var context = _a.context, props = _a.props, parent = _a.parent;
        return ({
            class: [
                // Font
                'tw-leading-[normal] tw-text-lg sm:tw-text-md',
                // Spacing
                'tw-m-0',
                'tw-p-3',
                // Base
                'tw-rounded-md tw-block tw-w-full tw-min-h-24',
                'tw-m-0 tw-outline-0 focus:tw-outline-0 tw-outline-transparent',
                'tw-border-0 tw-ring-1 tw-ring-inset',
                'dark:tw-ring-0',
                // Colors
                'tw-text-gray-900 tw-ring-gray-300 placeholder:tw-text-gray-400',
                'dark:tw-bg-zinc-500 dark:tw-text-gray-100 dark:autofill:tw-bg-zinc-600',
                { 'tw-border-gray-300 dark:tw-border-gray-600': !props.invalid },
                // Invalid State
                { 'tw-border-red-500 dark:tw-border-red-400': props.invalid },
                // States
                {
                    'hover:tw-border-primary': !context.disabled && !props.invalid,
                    'focus:tw-ring-2 focus:tw-outline-none dark:focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-primary-300': !context.disabled,
                    'tw-opacity-60 tw-select-none tw-pointer-events-none tw-cursor-default tw-bg-gray-100 tw-ring-gray-200': context.disabled,
                },
                // Filled State *for FloatLabel
                { filled: ((_b = parent.instance) === null || _b === void 0 ? void 0 : _b.$name) == 'FloatLabel' && props.modelValue !== null && ((_c = props.modelValue) === null || _c === void 0 ? void 0 : _c.length) !== 0 },
                // Misc
                'tw-appearance-none',
                'tw-transition-colors tw-duration-200',
            ],
        });
    },
};
